import React, { useEffect, useState } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../Firebase.js";
import { useNavigate } from "react-router-dom";
import { uid } from "uid";
import { db } from "../Firebase.js";
import { set, ref, onValue, remove, update } from "firebase/database";
import "../components/Homepage.css";

export default function Homepage() {
  const [todo, setTodo] = useState("");
  const [date, setDate] = useState("");

  const [isEdit, setIsEdit] = useState(false);
  const [todos, setTodos] = useState([]);
  const [tempUidd, setTempUidd] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        // read
        onValue(ref(db, `/${auth.currentUser.uid}`), (snapshot) => {
          setTodos([]);
          const data = snapshot.val();
          if (data !== null) {
            Object.values(data).map((todo) => {
              setTodos((oldArray) => [...oldArray, todo]);
            });
          }
        });
      } else if (!user) {
        navigate("/");
      }
    });
  }, []);

  // add
  const writeToDatabase = () => {
    const uidd = uid();
    set(ref(db, `/${auth.currentUser.uid}/${uidd}`), {
      todo: todo,
      uidd: uidd,
      date: date,
      status: "incomplete",
    });
    setTodo("");
  };

  // update
  const handleUpdate = (todo) => {
    setIsEdit(true);
    setTodo(todo.todo);
    setTempUidd(todo.uidd);
    setDate(todo.date);
  };
  const handleEditConfirm = () => {
    update(ref(db, `/${auth.currentUser.uid}/${tempUidd}`), {
      todo: todo,
      tempUidd: tempUidd,
      date: date,
    });
    setTodo("");
    setIsEdit(false);
  };

  const handleStatusConfirm = (uid, str) => {
    update(ref(db, `/${auth.currentUser.uid}/${uid}`), {
      status: str,
    });
    setIsEdit(false);
  };

  // delete
  const handleDelete = (uid) => {
    remove(ref(db, `/${auth.currentUser.uid}/${uid}`));
  };

  //sign out
  const handleSignOut = () => {
    signOut(auth)
      .then(() => {
        navigate("/");
      })
      .catch((err) => {
        alert(err.message);
      });
  };

  return (
    <div className="homepage">
      <input
        type="text"
        placeholder="Add new task.."
        className="add-edit-input"
        value={todo}
        onChange={(e) => setTodo(e.target.value)}
      />
      <input
        type="date"
        placeholder="Add Date"
        className="add-edit-input-date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
      />
      {todos.map((todo) => {
        let dates = new Date(todo.date);

        return (
          <div className="todo">
            
            <div className="display">{todo.todo}</div>
            <div className="display">
              {
                dates.getDate() +
                "-" +
                (parseInt(dates.getMonth()) + 1) +
                "-" +
                dates.getFullYear()
              }
            </div>

            <div className="display" >{todo.status}</div>

            <button
              fontSize="large"
              onClick={() => handleUpdate(todo)}
              className="edit-button"
            >
              Edit
            </button>
            <button
              fontSize="large"
              onClick={() => handleDelete(todo.uidd)}
              className="delete-button"
            >
              Delete
            </button>
            <button
              fontSize="large"
              onClick={() => handleStatusConfirm(todo.uidd, "complete")}
              className="complete-button"
            >
              Complete
            </button>
            <button
              fontSize="large"
              onClick={() => handleStatusConfirm(todo.uidd, "incomplete")}
              className="incomplete-button"
            >
              Incomplete
            </button>
          </div>
        );
      })}

      {isEdit ? (
              <div>
                <button onClick={handleEditConfirm} className="add-confirm-icon">
                  Update
                </button>
              </div>
            ) : (
              <div>
                <button onClick={writeToDatabase} className="add-confirm-icon">
                  Add Task
                </button>
              </div>
            )}

      <button onClick={handleSignOut} className="logout-icon">
        Sign Out
      </button>
    </div>
  );
}